module.exports = __webpack_public_path__ + "img/img-3-8mobile.1e2bdb3c.png";